import React, { Component } from 'react';
import Slide from './Slide';
import LeftArrow from './LeftArrow';
import RightArrow from './RightArrow';

class Slider extends Component {
  render() {
    // console.log('[Slider] this.props: ', this.props);
    return (
      <div className="slider">
        <div
          className="slider-wrapper"
          style={{
            transform: `translateX(${this.props.translateValue}px)`,
            transition: 'transform ease-out 0.45s'
          }}
        >
          {this.props.images
            ? this.props.images.map((image, i) => (
                <Slide key={image.ID} image={image.url} />
              ))
            : null}
        </div>
        <div
          className="flex justify-between relative ph3"
          style={{ top: 'calc(-50% - 40px)' }}
        >
          <LeftArrow
            className="f1 white pointer"
            goToPrevSlide={this.props.goToPrevSlide}
          />
          <RightArrow
            className="f1 white pointer"
            goToNextSlide={this.props.goToNextSlide}
          />
        </div>
      </div>
    );
  }
}

export default Slider;
